export const mesaPageMotion = {
  initial: { opacity: 0, y: 8 },
  animate: { opacity: 1, y: 0 },
  transition: { duration: 0.18, ease: [0.22, 1, 0.36, 1] }
};

export const productListMotion = {
  initial: "hidden",
  animate: "show",
  variants: {
    hidden: {},
    show: { transition: { staggerChildren: 0.035 } }
  }
};

export const productCardMotion = {
  variants: {
    hidden: { opacity: 0, y: 10 },
    show: { opacity: 1, y: 0 }
  },
  transition: { duration: 0.16 }
};

export const sheetMotion = {
  initial: { y: "100%" },
  animate: { y: 0 },
  exit: { y: "100%" },
  transition: { type: "spring", damping: 28, stiffness: 320 }
};

export const fadeIn = {
  initial: { opacity: 0 },
  animate: { opacity: 1 },
  exit: { opacity: 0 },
  transition: { duration: 0.2 }
};
